import type { Group, Option, SelectOption } from './types';

export const isGroupOption = <Value>(option: Option<Value> | Group<Value>): option is Group<Value> => {
  return !!(option as Group<Value>)?.options;
};

export const getAllOptions = <Value>(options: SelectOption<Value>[]): Option<Value>[] => {
  return options.reduce((previous: Option<Value>[], option) => {
    if (isGroupOption(option)) {
      return previous.concat(option.options);
    }

    return previous.concat(option);
  }, []);
};
